import { StatisticService } from 'app/shared/services/statistic.service';
import { TranslateService } from '@ngx-translate/core';
var CalendarActivityComponent = (function () {
    function CalendarActivityComponent(statsService, translateService) {
        this.statsService = statsService;
        this.translateService = translateService;
        this.days = [];
        this.currentMonth = '';
        this.emptyDays = [];
        this.dataMonth = [];
        this.updateCurrentMonth();
        this.getStatDataForMonth(this.currentMonth);
    }
    CalendarActivityComponent.prototype.getProgressForDay = function (day) {
        if (this.dataMonth.length == 0) {
            return 0;
        }
        var result = this.dataMonth.find(function (item) { return item.name == day.toString(); });
        if (!result) {
            return 0;
        }
        return result.value;
    };
    CalendarActivityComponent.prototype.getStatDataForMonth = function (month) {
        var _this = this;
        this.statsService.getMyStatisticForMonth(this.getMonthIndex(this.currentMonth) + 1).then(function (stats) {
            _this.dataMonth = [];
            var dayCounter = 1;
            for (var day = 0; day < _this.daysInThisMonth(); day++) {
                _this.dataMonth.push({
                    name: dayCounter,
                    value: stats[day] || 0,
                });
                dayCounter++;
            }
        });
    };
    CalendarActivityComponent.prototype.daysInThisMonth = function () {
        var now = new Date();
        return new Date(now.getFullYear(), this.getMonthIndex(this.currentMonth) + 1, 0).getDate();
    };
    CalendarActivityComponent.prototype.previousMonth = function () {
        var currentMonthIndex = this.getMonthIndex(this.currentMonth);
        if (currentMonthIndex > 0) {
            this.currentMonth = this.getMonthName(currentMonthIndex - 1);
            this.updateDays();
            this.getStatDataForMonth(this.currentMonth);
        }
    };
    CalendarActivityComponent.prototype.nextMonth = function () {
        var currentMonthIndex = this.getMonthIndex(this.currentMonth);
        if (currentMonthIndex < 11) {
            this.currentMonth = this.getMonthName(currentMonthIndex + 1);
            this.updateDays();
            this.getStatDataForMonth(this.currentMonth);
        }
    };
    CalendarActivityComponent.prototype.updateDays = function () {
        var currentMonthIndex = this.getMonthIndex(this.currentMonth);
        var daysInMonth = new Date(new Date().getFullYear(), currentMonthIndex + 1, 0).getDate();
        this.days = Array.from({ length: daysInMonth }, function (_, i) { return i + 1; });
    };
    CalendarActivityComponent.prototype.updateCurrentMonth = function () {
        var currentDate = new Date();
        this.currentMonth = this.getMonthName(currentDate.getMonth());
        this.emptyDays = Array.from({ length: currentDate.getDay() }, function (_, i) { return i; });
        this.updateDays();
    };
    CalendarActivityComponent.prototype.getMonthName = function (monthIndex) {
        var translationKey = "GENERAL.months." + monthIndex;
        return this.translateService.instant(translationKey);
    };
    CalendarActivityComponent.prototype.getMonthIndex = function (monthName) {
        // This function needs to find the index of the provided month name
        // in the current language
        for (var i = 0; i < 12; i++) {
            var translatedMonth = this.translateService.instant("GENERAL.months." + i);
            if (translatedMonth === monthName) {
                return i;
            }
        }
        return 0; // Default to January if not found
    };
    return CalendarActivityComponent;
}());
export { CalendarActivityComponent };



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/theme/components/activity-achievement/components/calender-activity.component.ts.pre-build-optimizer.js